import { DataSource } from 'typeorm';
import { InjectLoaderInput, ObjectInput } from './types';

// global variable dataSource with type DataSource
declare global {
  var dataSource: DataSource;
}

export function isObjectInput<V>(
  obj: InjectLoaderInput<V>
): obj is ObjectInput<V> {
  return (obj as ObjectInput<V>).fromEntity !== undefined;
}

export function validateInjectLoaderInput<V>(
  input: InjectLoaderInput<V>,
  dataloaderName: string
) {
  if (!input)
    throw new Error(
      `Invalid input recieved for @InjectLoader decorator at ResolveField:${dataloaderName}`
    );
}

// function to initialize the dataSource and assign a value to the global variable
export const addDataSource = (dataSource: DataSource) => {
  dataSource.initialize()
  globalThis.dataSource = dataSource;
}
